module.exports = __webpack_public_path__ + "static/media/boom-ontspanning.4dbb9ddf.png";